<div class="echarts" echarts [options]="chartOption" style="width: 100%;height:150px;"></div>